import * as React from "react";
import CustomDialog from "../Notifications/Dialog/index";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import DocumentNotApproveModal from "../../components/DocumentNotApproveModal/ItemDocumentNotApproveModal.js";
import FileViewTable from "../../components/DocumentNotApproveModal/FileViewTable.js";
import { msg } from "../../components/Notifications/MsgBox";
import { ContractMomService, AdjustmentService } from "../../services";

const MomDetailDeleteMOM = ({ open, onClose, title, transaction_no }) => {
  const [msgType, setMsgType] = React.useState("");
  const [propsTitle, setPropsTitle] = React.useState({ TextAlign: "center" });
  const [openLoading, setOpenLoading] = React.useState(false);
  const [attachments, SetAttachments] = React.useState([]);

  const [reasonCancelMOMs, SetReasonCancelMOMs] = React.useState([]);
  const [docTypeCancelMOMs, SetDocTypeCancelMOMs] = React.useState([]);

  const [deleteItem, SetDeleteItem] = React.useState({
    reason: "",
    description: "",
    documentType: "",
  });

  const handleOnInintial = async () => {
    onUploadComplete();

    try {
      const responseReasonCancelMOM = await AdjustmentService.getMaster(
        "ReasonCancelMOM"
      );
      if (responseReasonCancelMOM) {
        if (responseReasonCancelMOM.length > 0) {
          const itemReasonCancelMOMs = responseReasonCancelMOM
            .filter((p) => p.key === "ReasonCancelMOM")
            .map((item) => ({ value: item.value, text: item.display }));

          SetReasonCancelMOMs(itemReasonCancelMOMs);
        }
      }

      const responseDocTypeCancelMOM = await AdjustmentService.getMaster(
        "DocTypeCancelMOM"
      );
      if (responseDocTypeCancelMOM) {
        if (responseDocTypeCancelMOM.length > 0) {
          const itemDocTypeCancelMOMs = responseDocTypeCancelMOM
            .filter((p) => p.key === "DocTypeCancelMOM")
            .map((item) => ({ value: item.value, text: item.display }));

          SetDocTypeCancelMOMs(itemDocTypeCancelMOMs);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onChangeSelectedFile = (file, file_type) => {};

  const onUploadComplete = (modalId) => {
    try {
      setOpenLoading(true);
      ContractMomService.getAttachments(transaction_no)
        .then((response) => {
          console.log("getCommitteeAttachments");
          console.log(response);
          if (response.isSuccess) {
            let dataresponse = response.resData
              .filter((p) => p.file_category === "C0")
              .map((item, index) => {
                let _item = attachments.find((f) => f.running === item.running);
                if (_item != null) {
                  item.isActive = _item.isActive;
                } else if (item.isActive === null) {
                  item.isActive = true;
                }
                return item;
              });
            console.log(dataresponse);
            SetAttachments(dataresponse);
          }

          setOpenLoading(false);
        })
        .catch(() => {
          setOpenLoading(false);
        });
    } catch (e) {
      console.log(e);
      setOpenLoading(false);
    }
  };

  const onUploadCancel = (modalId) => {};

  const onDeleteConfirm = (event, item, index) => {
    console.log("onDeleteConfirm => :");
    console.log(index);
    if (index != null) {
      msg.showConfirm(
        "Confirm",
        "ต้องการลบรายการนี้หรือไม่",
        () => {
          msg.hideConfirm();

          let tempAttachments = attachments;

          tempAttachments[index].isActive = false;

          console.log(tempAttachments);
          SetAttachments((prevoius) =>
            prevoius.map((ele) => {
              if (ele.running === item.running) {
                return { ...ele, isActive: false };
              } else {
                return ele;
              }
            })
          );

          msg.success("ลบรายการสำเร็จ");
        },
        () => {
          msg.hideConfirm();
          console.log("ยกเลิกการลบรายการ");
        },
        () => {
          console.log("ยกเลิกการลบรายการ");
        }
      );
    }
  };

  const handleOnChange = (event) => {
    const v = event.target.value;
    const n = event.target.name;

    console.log("event.target", event.target);

    SetDeleteItem((previous) => ({ ...previous, [n]: v }));
  };

  const handleOnConfirm = async () => {

    if(deleteItem.reason)
    {
      if(!(deleteItem.reason === 'อื่นๆ' && (deleteItem.description + "").trim() === ''))
      {
        let objs = {...deleteItem, transaction_no: transaction_no};

        try {
            setOpenLoading(true);
            ContractMomService.confirmDeleleMom(objs)
              .then((response) => {
                console.log("confirmDeleleMom");
                console.log(response);
                if (response.success) {
                    msg.success(`ลบสำเร็จ\r\nเลขที่เอกสาร/MOM No: ${response.data}`);
                    window.location.reload(true)
                }else{
                    msg.error(response.message)
                }
      
                setOpenLoading(false);
              })
              .catch(() => {
                setOpenLoading(false);
              });
          } catch (e) {
            console.log(e);
            setOpenLoading(false);
          }
      }
    }
  };

  const handelOpenIploadFile = () => {
    window.$("#attachedCancelMomModal").modal("show");
  };

  React.useEffect(() => {
    handleOnInintial();
  }, [transaction_no]);

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title={title}
      msgType={msgType}
      propsTitle={propsTitle}
    >
      <Grid container spacing={2}>
        <Grid item md={3} xs={4}>
          <Typography>
            <span className="required">*</span> เหตุผล
          </Typography>
        </Grid>
        <Grid item md={9} xs={8}>
          <FormControl fullWidth size="small">
            <Select
              variant="outlined"
              displayEmpty
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
              defaultValue={deleteItem.reason}
              name="reason"
              onChange={handleOnChange}
            >
              <MenuItem value="">
                <em>--Select--</em>
              </MenuItem>
              {reasonCancelMOMs.map((p, i) => (
                <MenuItem key={"reason-item-" + i} value={p.value}>
                  {p.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={3} xs={4}>
          <Typography>คำอธิบาย</Typography>
        </Grid>
        <Grid item md={9} xs={8}>
          <TextField
            size="small"
            variant="outlined"
            multiline={true}
            minRows={3}
            fullWidth
            defaultValue={deleteItem.description}
            name="description"
            onChange={handleOnChange}
            inputProps={{ maxLength: 400 }}
            error={deleteItem.reason === 'อื่นๆ' && (deleteItem.description + "").trim() === ''}
            helperText={deleteItem.reason === 'อื่นๆ' && (deleteItem.description + "").trim() === '' ? 'กรุณาระบุ คำอธิบาย' : ''}
          ></TextField>
        </Grid>
        <Grid item md={3} xs={4}>
          <Typography>ประเภทเอกสาร</Typography>
        </Grid>

        <Grid item md={9} xs={8}>
          <FormControl fullWidth size="small">
            <Select
              variant="outlined"
              displayEmpty
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
              name="documentType"
              onChange={handleOnChange}
              value={deleteItem.documentType}
            >
              <MenuItem value="">
                <em>--Select--</em>
              </MenuItem>
              {docTypeCancelMOMs.map((p, i) => (
                <MenuItem value={p.value}>{p.text}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} container justifyContent="flex-end">
          <Button
            color="primary"
            variant="outlined"
            style={{ textTransform: "none" }}
            startIcon={<CloudUploadOutlinedIcon></CloudUploadOutlinedIcon>}
            onClick={handelOpenIploadFile}
          >
            Upload File
          </Button>
        </Grid>
        <Grid item xs={12} className="sp-table-container">
            <FileViewTable items={attachments} onDeleteConfirm={onDeleteConfirm} readonly={false}></FileViewTable>
          <DocumentNotApproveModal
            model_id="attachedCancelMomModal"
            transaction_no={transaction_no}
            file_category={"C0"}
            dataId={transaction_no}
            onChangeSelectedFile={(selectedFile, file_type) =>
              onChangeSelectedFile(selectedFile, file_type)
            }
            onUploadComplete={(attmentid) => onUploadComplete(attmentid)}
            onUploadCancel={(attmentid) => onUploadCancel(attmentid)}
            defaultFileName="เอกสารยกเลิก MOM"
          ></DocumentNotApproveModal>
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          <Button onClick={handleOnConfirm}>
            <div>
              <img src="../../../assets/images/icons/btn-order-check-green.png" />
              <br />
              <span>ตกลง</span>
            </div>
          </Button>
          <Button onClick={onClose}>
            <div>
              <img src="../../../assets/images/icons/btn-cancel.png" />
              <br />
              <span>ยกเลิก</span>
            </div>
          </Button>
        </Grid>
      </Grid>
    </CustomDialog>
  );
};

export default MomDetailDeleteMOM;
